module.exports = __webpack_public_path__ + "static/img/document-07.5527b270.svg";